<template>
  <div class="publish-dynamic">
    <div class="publish-cont">
      <label>描述</label>
      <textarea v-model="content" placeholder="请输入您要发布的内容(最多500字)..." v-on:input="contentLent()"></textarea>
    </div>
    <div
      v-show="loading"
      v-loading="loading"
      :element-loading-text="loadNum"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.2)"
      :data="videoUrl"
      class="loading"
      style
    ></div>
    <div class="publish-classify">
      <label>分类</label>
      <div class="type" @click.stop="typeSlide">
        <span v-text="names"></span>
        <i class="iconfont icon-triangle-down"></i>
      </div>
      <ul v-if="typeShow" class="type-list">
        <li
          v-for="(item,index) in typeName"
          :key="index"
          @click.stop="name(item.title,item.type)"
        >{{item.title}}</li>
      </ul>
    </div>
    <div class="upload">
      <div class="top">图片/视频 &nbsp;&nbsp;&nbsp; 图片最多上传9张、视频不超过50M</div>
      <div class="add-box">
        <ul class="img-box">
          <li v-for="(item,index) in imgUrl" :key="index">
            <img :src="item" alt />
            <span class="del" @click="deleteImg(item.url)">x</span>
          </li>
        </ul>
        <label class="add-img" for="input">
          <img src="../../assets/img/add.png" alt />
          <input type="file" id="input" @change="getFile($event)" multiple />
        </label>
      </div>
    </div>
    <div class="save-btn">
      <div class="btn-list active" @click="senseWord">发布</div>
      <!-- <div class="btn-list">保存草稿</div>
      <div class="btn-list">客户端浏览</div>-->
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import axios from "axios";
import { stringify } from "querystring";
import { log } from "util";
var ImgData = {};
export default {
  // name: "App",
  data() {
    return {
      typeShow: false,
      names: "图片",
      typeName: [
        {
          title: "图片",
          type: 1
        },
        {
          title: "视频",
          type: 2
        }
      ],
      uploadType: 1,
      uploadUrl: "https://admin.jzda001.com/tools/uploadFileForJson",
      uploadImgList: [],
      imgUrl: [],
      videoUrl: "",
      content: "",
      se: [],
      sensi: "",
      parmaList: [],
      videoWidth: "",
      videoHeight: "",
      loading: false,
      number: 0,
      loadNum:""
    };
  },
  mounted() {
    this.getPublishSum();
  },
  methods: {
    getPublishSum() {
      this.$http
        .get("/api/media/015-getPublishSum", {
          params: {
            token: this.$store.state.userInfo.token
          }
        })
        .then(res => {
          if (res.data.code == 0) {
            this.number = res.data.rows[0];
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    contentLent() {
      if (this.content.length > 500) {
        this.$message("最多500字");
        this.content = this.content.substring(0, 500);
      }
    },
    typeSlide() {
      this.typeShow = !this.typeShow;
    },
    name(name, type) {
      this.typeShow = false;
      this.names = name;
      this.uploadType = type;
      this.uploadImgList = [];
      $(".img-box").html("");
      $(".add-img").show();
      if (type == 1) {
        this.videoUrl = "";
        this.uploadUrl = "https://admin.jzda001.com/tools/uploadFileForJson";
      } else {
        this.imgUrl = [];
        this.uploadUrl = "https://admin.jzda001.com/tools/uploadMp4ForJson";
      }
    },
    getFile(e) {
      if (this.uploadType == 2) {
        this.loading = true;
      }
      if (e.target.files) {
        var eLength;
        if (e.target.files.length > 9) {
          eLength = 9;
          this.$message("最多上传9张图片");
        } else {
          eLength = e.target.files.length;
        }
        for (let i = 0; i < eLength; i++) {
          let param = new FormData();
          param.append("file", e.target.files[i]);
          var that = this;
          var config = {
            headers: { "Content-Type": "multipart/form-data" },
            onUploadProgress: function(e) {
              if (e.lengthComputable) {
                var progress = parseInt((e.loaded / e.total) * 100);
                that.loadNum = "已加载" + progress + "%";
              }
            }
          };
          axios.post(this.uploadUrl, param, config)
          .then(res => {
            console.log(res, "上传图片");
            if (res.status == 200) {
              if (this.uploadType == 1) {
                this.imgUrl.push(res.data.url);
              }
              if (this.uploadType == 2) {
                var size =
                  res.data.size.substring(0, res.data.size.length - 3) * 1;
                console.log(size);
                if (size > 50) {
                  this.$message("视频大小不得超过50M");
                  return false;
                }
                this.imgUrl.push(res.data.shotPath);
                this.videoUrl = res.data.url;
                this.loading = false;
                var img_url = res.data.shotPath;
                var img = new Image();
                img.src = img_url;
                img.onload = function() {
                  ImgData.videoWidth = img.width;
                  ImgData.videoHeight = img.height;
                };
              }
              if (this.uploadType == 1 && this.imgUrl.length >= 9) {
                $(".add-img").hide();
              }
              if (this.uploadType == 2 && this.imgUrl.length >= 1) {
                $(".add-img").hide();
              }
            }
          });
        }
      }
    },
    deleteImg(delUrl) {
      //删除当前图片
      $(this)
        .parent("li")
        .remove();
      this.imgUrl.splice($.inArray(delUrl, this.imgUrl), 1);
      if (this.uploadType == 2) {
        this.imgUrl = [];
        this.videoUrl = "";
        $(".add-img").show();
      }
    },
    senseWord() {
      if (this.number >= 8) {
        this.$message("一天最多可以发布8次哦~");
        return false;
      }
      //敏感词汇
      this.se = [];
      this.$http
        .get("/api/media/012--sensitivewordList", {
          params: {
            token: this.$store.state.userInfo.token
          }
        })
        .then(res => {
          if (res.data.code == 0) {
            var self = this;
            $.each(res.data.rows, function(k, v) {
              self.se.push(self.content.indexOf(v.keyWord));
            });
            if (self.se.indexOf(0) != -1) {
              this.$message("很抱歉,您发布的内容含有敏感词汇,无法上传");
            } else {
              this.pub();
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    pub() {
      //发布
      this.$http
        .get("/api/media/013-dongTaiAdd", {
          params: {
            type: this.uploadType,
            title: this.content,
            quanXian: 1,
            imgUrl: this.imgUrl.join(","),
            videoUrl: this.videoUrl,
            videoWidth: ImgData.videoWidth,
            videoHeight: ImgData.videoHeight,
            token: this.$store.state.userInfo.token
          }
        })
        .then(res => {
          if (res.data.code == 0) {
            this.$parent.num++;
            this.$message("发布成功");
            this.names = "图片";
            this.uploadType = 1;
            this.content = "";
            this.imgUrl = [];
            this.videoUrl = "";
            this.uploadImgList = [];
          } else {
            this.$message(res.data.msg);
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style scoped>
#input {
  display: none;
}
.publish .btn-list {
  margin: 0px auto;
  float: none;
}
.publish .publish-classify label {
  width: 70px;
  text-align: right;
}
.publish .publish-classify {
  padding-left: 50px;
}
.publish .publish-classify .type {
  margin-left: 20px;
  border-color: #ccc;
}
.publish .publish-classify .type-list {
  left: 140px;
}
.loading {
  width: 200px;
  height: 200px;
  float: left;
  position: absolute;
  left: 50%;
  top: 40%;
  margin: -100px 0px 0px -100px;
}
</style>
<style>
.el-loading-spinner i {
  color: #2e8043 !important;
  font-size: 50px !important;
}
.el-loading-mask {
  border-radius: 6px;
}
.el-loading-spinner {
  top: 35% !important;
}
.el-loading-spinner .el-loading-text {
  text-align: center;
  font-size: 16px !important;
  color: #2e8043 !important;
  margin: 15px auto !important;
}
</style>